import React, { useEffect, useState } from 'react';
import { ToggleButton, Toast, useT } from '@repo/common';
import {
  getEmailNotificationSetting,
  updateEmailNotificationSetting,
} from '../../../api/user/user.api';

/** 이메일 알림(Q&A 답변 등) 수신 토글 */
export default function EmailNotificationSettingRow() {
  const t = useT();
  const [enabled, setEnabled] = useState(null);
  const [busy, setBusy] = useState(false);
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    getEmailNotificationSetting()
      .then((data) => setEnabled(Boolean(data?.emailEnabled)))
      .catch((error) => console.error('Email notification setting could not be loaded', error));
  }, []);

  const handleToggle = async (on) => {
    if (enabled === null || busy) return;
    setBusy(true);
    setEnabled(on);
    try {
      const next = await updateEmailNotificationSetting(on);
      setEnabled(Boolean(next?.emailEnabled));
      setToastMessage(
        next?.emailEnabled
          ? t('Email notifications turned on.', '이메일 알림을 켰어요.')
          : t('Email notifications turned off.', '이메일 알림을 껐어요.'),
      );
    } catch (error) {
      console.error('Email notification setting update failed', error);
      setEnabled(!on);
    } finally {
      setBusy(false);
    }
  };

  return (
    <>
      <div className='flex items-center w-full'>
        <div className='flex min-w-0 flex-1 flex-col gap-0.5 pr-2'>
          <p className='typo-b14Strong text-text-primary'>
            {t('Email notifications', '이메일 알림')}
          </p>
          <p className='typo-b12 text-text-placeholder'>
            {t(
              'Get emails when your questions are answered and other updates on your activity',
              '내 질문에 답변이 달리는 등 활동 소식을 메일로 받아요',
            )}
          </p>
        </div>
        <ToggleButton value={Boolean(enabled)} onChange={handleToggle} />
      </div>
      {toastMessage && (
        <div className='fixed bottom-6 left-0 right-0 px-4 z-[1000] flex justify-center'>
          <Toast
            type='success'
            state='white'
            title={toastMessage}
            direction='up'
            customWidth='auto'
            onClose={() => setToastMessage('')}
          />
        </div>
      )}
    </>
  );
}
